/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_TitleInputs */

const da_privacy_data_title = /** @type {(inputs: Privacy_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvilke oplysninger vi behandler`)
};

/** @type {(inputs: Privacy_Data_TitleInputs) => LocalizedString} */
const en_privacy_data_title = da_privacy_data_title;

/**

* @param {Privacy_Data_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_title = /** @type {((inputs?: Privacy_Data_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_title(inputs)
	return /** @type {LocalizedString} */ ("Hvilke oplysninger vi behandler")
});